import type { FeatureFlagConfig } from '@platform/client/features';

declare module '@platform/core/feature-flags' {
  interface FeatureFlags {
    THREAT_INTEL_SKU?: boolean;
    THREAT_INTEL_FEED?: boolean;
  }
}

export default {
  featureFlags: {
    THREAT_INTEL_SKU: true,
    THREAT_INTEL_FEED: undefined,
  },
} satisfies FeatureFlagConfig;
